import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loadingStore', {
  state: () => ({
    loadNestingLevel: 0,
  }),
  actions: {
    show() {
      this.loadNestingLevel++;
    },
    hide() {
      if (this.loadNestingLevel > 0) {
        this.loadNestingLevel--;
      }
    },
  },
  getters: {
    isLoading: state => state.loadNestingLevel > 0,
  },
});
